<template>
  <h2>
    {{ $t('interiorDesign') }}
  </h2>
  <div style="scroll-behavior: smooth">
    <div class="main-info">
      <div
        id="how-to-switch-to-the-interior-design-mode"
        ref="how-to-switch-to-the-interior-design-mode"
        class="paragraph-block"
      >
        <h3 id="switchInteriorDesmode">
          {{ $t('switchInteriorDesmode') }}
        </h3>
        <p class="paragraph-text">
          {{ $t('interiorDesignMode') }}
        </p>
        <p class="paragraph-text">
          {{ $t('selectingCreateDesign') }}
        </p>
        <div v-if="locale === 'ru'" class="image-carousel">
          <ImagesCustomSlider
            :height="null"
            width="100%"
            :images="[
              `${staticUrl}/images/interior-design-how1.webp`,
              `${staticUrl}/images/interior-design-how2.webp`,
              `${staticUrl}/images/interior-design-how3.webp`,
            ]"
          />
        </div>
        <div v-else class="image-carousel">
          <ImagesCustomSlider
            :height="null"
            width="100%"
            :images="[
              `${staticUrl}/images/interior-design-en-how1.webp`,
              `${staticUrl}/images/interior-design-en-how2.webp`,
              `${staticUrl}/images/interior-design-en-how3.webp`,
            ]"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import {onMounted, ref} from 'vue';
import {useI18n} from 'vue-i18n';
import {useHead, useRuntimeConfig} from '#imports';

export default {
  setup() {
    const {t} = useI18n();
    const isShowFeedBackModal = ref(false);
    const runtimeConfig = useRuntimeConfig();
    const staticUrl = runtimeConfig.public.vueAppStaticUrl;

    useHead({
      title: `${t('DreamFlat')} - ${t('interiorDesign')}`,
      meta: [
        {
          name: 'description',
          content: `${t('interiorDesignMetaDesc')}`,
        },
      ],
    });
    useSeoMeta({
      ogTitle: `${t('DreamFlat')} - ${t('interiorDesign')}`,
      description: `${t('interiorDesignMetaDesc')}`,
      ogDescription: `${t('interiorDesignMetaDesc')}`,
      ogImage: 'https://dreamflat.design/prev.webp',
    });

    const {locale} = useI18n();

    return {
      slide: ref(1),
      locale,
      mobileNavMenu: ref(false),
      isShowFeedBackModal,
      staticUrl,
    };
  },
};
</script>
<style lang="scss" scoped>
@import 'css/help-center/help-center-general-ctyle';
</style>
